import { Middleware } from 'redux'
import modules from '@modules'
import { vocApi, lcmApi, caseApi } from '@services/api/index'
import useClientConfig from 'config/clients/useClientConfig'

const AuthActions = modules.actions.auth

const interceptorMiddleware: Middleware = (store) => {
  let interceptorsBinded = false
  const { getClientName, getPublicUrl } = useClientConfig()

  return (next) => (action) => {
    if (!interceptorsBinded) {
      interceptorsBinded = true

      const monitor = (response: any) => {
        if (response.status === 401 || response.status === 403) {
          // Solo cerramos sesión y redirigimos si es oxxo-retail (solicitud de cliente)
          if (getClientName() !== 'oxxo-retail') {
            return
          }

          if (response.config?.url && response.config.url.indexOf('authenticate') === -1) {
            // Guardamos la ruta actual para volver después del login (excepto si ya estamos en /login)
            if (window.location.pathname !== '/login') {
              sessionStorage.setItem('beforeLogin', window.location.pathname)
            }
            // Limpiamos el store persistido para evitar que queden estados corruptos (ej. JSONs de error)
            localStorage.removeItem('persist:root')
            
            store.dispatch(AuthActions.signout())
            
            // Forzamos la redirección y recarga limpia de la aplicación respetando el publicUrl (/voc)
            const publicUrl = getPublicUrl() || ''
            window.location.href = `${publicUrl}/login`
          }
        }
      }

      vocApi.addMonitor(monitor)
      lcmApi.addMonitor(monitor)
      caseApi.addMonitor(monitor)
    }

    return next(action)
  }
}

export default interceptorMiddleware
